export default __webpack_public_path__ + "static/ekaterra_tl-8e27d294b547ca07255b0fa1532808d8.png";